import React from 'react';

import { IActiveIngredientsStrengthDisplay } from './types';

import * as Styled from './styles';
import { FormInput } from '@common/components/FormInput/styles';
import { StyledLabel } from '@common/components/Input/styles';
import { formatActiveIngredientName } from '../ActiveIngredientsSelection/hooks/useActiveIngredientSelection/helpers';

export const ActiveIngredientsStrengthDisplay = ({ activeIngredients }: IActiveIngredientsStrengthDisplay) => {
  const numerators = activeIngredients.map((a) => ({ unit: a.numeratorUnit, value: a.numeratorValue, name: a.name }));
  const denominator = { unit: activeIngredients[0].denominatorUnit, value: activeIngredients[0].denominatorValue };

  const renderContent = () => {
    return numerators?.map((item, index) => (
      <Styled.ActiveIngredient key={index}>
        <Styled.ActiveIngredientName>
          <FormInput
            className={'display'}
            disabled={true}
            name={`activeIngredient.name`}
            value={formatActiveIngredientName(item.name)}
          />
        </Styled.ActiveIngredientName>
        <Styled.InputSection>
          <FormInput
            className={'display'}
            disabled={true}
            name={`activeIngredientNumerator.value`}
            value={item!.value!}
            data-testid={`readonly-active-ingredient-numerator-value-${index}`}
          />
          <FormInput
            className={'display'}
            disabled={true}
            name={`activeIngredientNumerator.unit`}
            value={item!.unit!}
            data-testid={`readonly-active-ingredient-numerator-unit-${index}`}
          />
        </Styled.InputSection>
        <Styled.InputSection>
          <FormInput
            className={'display'}
            disabled={true}
            name={`activeIngredientDenominator.value`}
            value={denominator && denominator.value?.toString()}
            data-testid={`readonly-active-ingredient-denominator-value-${index}`}
          />
          <FormInput
            className={'display'}
            disabled={true}
            name={`activeIngredientNumerator.unit`}
            value={denominator && denominator.unit!}
            data-testid={`readonly-active-ingredient-denominator-unit-${index}`}
          />
        </Styled.InputSection>
      </Styled.ActiveIngredient>
    ));
  };

  return (
    <Styled.ActiveIngredientsStrength>
      <Styled.Labels>
        <StyledLabel>Active Ingredient (s)</StyledLabel>
        <StyledLabel>Ingredient strength</StyledLabel>
        <StyledLabel>Per</StyledLabel>
      </Styled.Labels>
      <Styled.ActiveIngredientsList>{renderContent()}</Styled.ActiveIngredientsList>
    </Styled.ActiveIngredientsStrength>
  );
};
